import { useEffect, useRef, useState } from "react";

export const useCountdownTimer = (initialTime: number, callback: (timeLeft: number) => void) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (timeLeft <= 0) return;

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = prev - 1;
        callback(newTime);

        if (newTime <= 0 && timerRef.current) {
          clearInterval(timerRef.current);
        }
        return newTime;
      });
    }, 1000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [timeLeft, callback]);

  const startTimer = () => {
    setTimeLeft(initialTime);
    callback(initialTime);
  };

  return { timeLeft, startTimer };
};
